/**
 * Converts a number of seconds to a formatted string in the format 'hh:mm:ss' or 'mm:ss'.
 * @memberof Number
 * @instance
 * @function
 * @returns {string|null} - The formatted time string, or null if the input string is empty or undefined.
 */
Number.prototype.toHHMMSS = function () {
  if (!this) return null;
  var sec_num = parseInt(this, 10); // don't forget the second param
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;
  var formattedTime;

  if (hours < 10) {
    hours = '0' + hours;
  }
  if (minutes < 10) {
    minutes = '0' + minutes;
  }
  if (seconds < 10) {
    seconds = '0' + seconds;
  }

  if (hours == '00') {
    formattedTime = minutes + ':' + seconds;
  } else {
    formattedTime = hours + ':' + minutes + ':' + seconds;
  }

  return formattedTime;
};

/**
 * Converts a formatted time string in the format 'hh:mm:ss' to the number of seconds.
 * @memberof String
 * @instance
 * @function
 * @returns {number|null} - The number of seconds, or null if the input string is empty or undefined.
 */
String.prototype.toSeconds = function () {
  if (!this) return null;
  var hms = this.split(':');
  return +hms[0] * 60 * 60 + +hms[1] * 60 + (+hms[2] || 0);
};
